import React from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';

import SmsForm from '../../../../components/SiteAdmin/SmsMethod/SmsForm/SmsForm';
import Loader from '../../../../components/Common/Loader/Loader';
import NotFound from '../../../../components/NotFound/NotFound';
import getSmsMethodQuery from './getSmsMethod.graphql';
import messages from '../../../../locale/messages';
import { withQuery } from '../../../../hoc/withGraphql';
import { decode, censorWord } from '../../../../helpers/queryEncryption';
import { salesUser } from '../../../../helpers/demoRestriction/demo';
class EditSmsMethod extends React.Component {
  render() {
    const { smsMethod: { loading, getSmsMethod }, adminId, isDemoRestricted } = this.props;
    const { formatMessage } = this.props.intl;

    let initialValues = {};

    if (!loading && getSmsMethod) {
      const data = getSmsMethod?.result;
      initialValues = {
        id: data?.id,
        accountId: (isDemoRestricted == 'true' && salesUser.indexOf(adminId) < 0) ? censorWord(decode(data?.accountId)) : decode(data?.accountId),
        securityId: (isDemoRestricted == 'true' && salesUser.indexOf(adminId) < 0) ? censorWord(decode(data?.securityId)) : decode(data?.securityId),
        phoneNumber: (isDemoRestricted == 'true' && salesUser.indexOf(adminId) < 0) ? censorWord(decode(data?.phoneNumber)) : decode(data?.phoneNumber),
        phoneDialCode: data?.phoneDialCode,
        phoneCountryCode: data?.phoneCountryCode,
        status: data?.status,
      };
    } 

    if (!loading && !getSmsMethod?.result?.id) {
      return <NotFound title={formatMessage(messages.pageNotFound)} />;
    } else {
      return (
        <Loader type={"page"} show={loading}>
          {!loading && <SmsForm initialValues={initialValues} />}
        </Loader>
      );
    }
  }
}

export default compose(
  injectIntl,
  withQuery(getSmsMethodQuery, {
    name: 'smsMethod',
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only',
      variables: {
        id: Number(props.id)
      }
    })
  }))(EditSmsMethod);
